import { useEffect, useRef, useState } from 'react';
import { fetchSlotDataForDate, setAndHandleDate, updateSelectedAndNextDates } from '../util';

export default (location: any, selectedDate: any, selectedSlots: any, setSelectedDate: any) => {
  const [nextDate, setNextDate] = useState(null);
  const [isMoreDate, setIsMoreDate] = useState(false);
  const [futureSlotData, setFutureSlotData] = useState({});
  const hasInitializedSelectedAndNextDates = useRef(false);

  useEffect(() => {
    const slots = location && location.timeZone && location.slots;

    if (slots && (!hasInitializedSelectedAndNextDates.current || (!selectedSlots && !nextDate))) {
      updateSelectedAndNextDates({
        location,
        selectedSlots,
        setSelectedDate,
        setNextDate,
        setIsMoreDate,
      });
      hasInitializedSelectedAndNextDates.current = true;
    }
  }, [
    hasInitializedSelectedAndNextDates,
    location,
    nextDate,
    selectedSlots,
    setIsMoreDate,
    setNextDate,
    setSelectedDate,
  ]);

  useEffect(() => {
    if (isMoreDate && selectedDate && !(selectedDate.format('YYYY-MM-DD') in futureSlotData)) {
      fetchSlotDataForDate({ futureSlotData, location, selectedDate, setFutureSlotData });
    }
  }, [futureSlotData, isMoreDate, location, selectedDate]);

  const handleDateChange = ({ isMoreDate, nextDate, selectedDate }: any) => {
    setAndHandleDate({
      futureSlotData,
      setFutureSlotData,
      isMoreDate,
      setIsMoreDate,
      selectedDate,
      setSelectedDate,
      nextDate,
      setNextDate,
      location,
    });
  };

  return { nextDate, isMoreDate, futureSlotData, handleDateChange, setIsMoreDate };
};
